import { render, staticRenderFns } from "./RequestList.vue?vue&type=template&id=7447ff50&scoped=true&"
import script from "./RequestList.vue?vue&type=script&lang=js&"
export * from "./RequestList.vue?vue&type=script&lang=js&"
import style0 from "./RequestList.vue?vue&type=style&index=0&id=7447ff50&prod&lang=scss&scoped=true&"
import style1 from "./RequestList.vue?vue&type=style&index=1&id=7447ff50&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7447ff50",
  null
  
)

export default component.exports